import { TierFields } from './tier-fields';
import type { PromotionAction } from '~/lib/schemas/actions';

type Action = Extract<PromotionAction, { type: 'fixed-price' }>;

interface Props {
	value: Action;
	onChange: (next: Action) => void;
}

export function FixedPriceBody({ value, onChange }: Props) {
	return (
		<div className="flex flex-col gap-4">
			<TierFields value={value} onChange={tf => onChange({ ...value, ...tf })} valueLabel="price" />
		</div>
	);
}
